import { isInOtherBrowsers, Uuid } from '@flowus/common';
import { appI18n } from '@flowus/common/i18n';
import { $downloadManager } from 'src/services/download-manager';
import { isFlowUsApp } from 'src/utils/electron-util';

// const changeDataType = (url: string) => {
//   return fetch(url, { mode: 'no-cors' })
//     .then((response) => {
//       return response.blob();
//     })
//     .then((blob) => {
//       return URL.createObjectURL(blob);
//     });
// };

export const downloadUrlFile = async (url: string, fileName?: string) => {
  if (isFlowUsApp.check) {
    void $downloadManager.download({
      id: Uuid.v4(),
      url,
      fileName: (fileName || guessFileName(url)).replace('/', '-'),
    });

    return;
  }
  if (isInOtherBrowsers()) {
    downloadFileNoBlank(url, fileName);
    return;
  }
  const $a = document.createElement('a');
  if (fileName) {
    $a.download = fileName;
  }
  $a.target = '_blank';
  $a.href = url;
  const evt = new MouseEvent('click', {
    // some micro front-end framework， window maybe is a Proxy
    view: document.defaultView,
    bubbles: true,
    cancelable: false,
  });
  $a.dispatchEvent(evt);
};

export const guessFileName = (url: string) => {
  try {
    // 首先尝试从 URL 的 query 参数中获取 filename
    const urlObj = new URL(url);
    const filenameFromQuery = urlObj.searchParams.get('filename');
    if (filenameFromQuery) {
      // URL 解码文件名
      return decodeURIComponent(filenameFromQuery);
    }
  } catch (e) {
    // URL 解析失败，继续使用路径提取
  }

  // 如果 query 参数中没有 filename，则从路径中提取
  const queryIndex = url.indexOf('?');
  let pathUrl = url;
  if (queryIndex > 0) {
    pathUrl = url.substring(0, queryIndex);
  }
  if (!pathUrl.endsWith('/')) {
    const index = pathUrl.lastIndexOf('/') + 1;
    if (index > 0) {
      const filename = pathUrl.substring(index);
      // 对路径中的文件名也进行 URL 解码
      try {
        return decodeURIComponent(filename);
      } catch (e) {
        return filename;
      }
    }
  }
  return appI18n.t('common.utils.unknown_filename');
};

/** 真·不需要另外新开窗户就能下载 */
export const downloadFileNoBlank = (url: string, fileName?: string) => {
  if (isFlowUsApp.check) {
    void $downloadManager.download({
      id: Uuid.v4(),
      url,
      fileName: (fileName || guessFileName(url)).replace('/', '-'),
    });
    return;
  }
  const elem = document.createElement('a');
  elem.download = fileName || guessFileName(url);
  elem.href = url;
  elem.click();
};
